import { useEffect, useState } from "react";
import { navLinks, tickerItems } from "@/mocks/comics";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* update ticker pressed at the very top */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="flex w-full items-center gap-3 px-4 md:px-6 lg:px-8 h-9">
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 text-xs font-medium text-accent-300">
            <i className="ri-flashlight-line text-sm" aria-hidden="true"></i>
            更新速递
          </span>
          <span className="hidden sm:block h-3 w-px bg-background-50/30 shrink-0"></span>
          <div className="marquee-pause relative flex-1 overflow-hidden">
            <div className="ticker-track animate-ticker-scroll">
              {[...tickerItems, ...tickerItems].map((item, idx) => (
                <span
                  key={`${item.id}-${idx}`}
                  className="mr-8 inline-flex items-center gap-2 text-xs text-background-100"
                >
                  <i className="ri-record-circle-line text-[6px] text-accent-400" aria-hidden="true"></i>
                  {item.text}
                  <span className="text-background-50/50">{item.time}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* nav */}
      <div
        className={`w-full transition-colors duration-300 ${
          solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
        }`}
      >
        <div className="flex w-full items-center justify-between gap-4 px-4 md:px-6 lg:px-8 h-16">
          <a
            href="#top"
            className={`flex items-center gap-2 shrink-0 font-heading text-xl tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-book-3-line text-lg" aria-hidden="true"></i>
            </span>
            香香漫画
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.target}
                href={`#${link.target}`}
                className={`rounded-md px-3 py-2 text-sm transition-colors whitespace-nowrap ${
                  solid
                    ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                    : "text-background-100 hover:bg-background-50/10 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#latest"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-base" aria-hidden="true"></i>
              开始阅读
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors md:hidden ${
                solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.target}
                  href={`#${link.target}`}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}